import { ProductFamily } from "@/lib/nav";
const contemporaryKitchen1 = "https://media.lacontessina.com/site/src/assets/products/contemporary-kitchen-1.jpg";
const contemporaryFurniture1 = "https://media.lacontessina.com/site/src/assets/products/contemporary-furniture-1.webp";
const contemporaryFurniture2 = "https://media.lacontessina.com/site/src/assets/products/contemporary-furniture-2.webp";
const contemporaryFurniture3 = "https://media.lacontessina.com/site/src/assets/products/contemporary-furniture-3.webp";
const contemporaryFurniture4 = "https://media.lacontessina.com/site/src/assets/products/contemporary-furniture-4.webp";
const contemporaryFurniture5 = "https://media.lacontessina.com/site/src/assets/products/contemporary-furniture-5.webp";
const contemporaryFurniture6 = "https://media.lacontessina.com/site/src/assets/products/contemporary-furniture-6.webp";
const contemporaryFurniture7 = "https://media.lacontessina.com/site/src/assets/products/contemporary-furniture-7.webp";
const contemporaryFurniture8 = "https://media.lacontessina.com/site/src/assets/products/contemporary-furniture-8.webp";
const contemporaryFurniture9 = "https://media.lacontessina.com/site/src/assets/products/contemporary-furniture-9.webp";
const contemporaryFurniture10 = "https://media.lacontessina.com/site/src/assets/products/contemporary-furniture-10.webp";
const contemporaryKitchen2 = "https://media.lacontessina.com/site/src/assets/products/contemporary-kitchen-2.jpg";
const contemporaryKitchen3 = "https://media.lacontessina.com/site/src/assets/products/contemporary-kitchen-3.jpg";
const contemporaryWardrobe1 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-1.jpg";
const contemporaryWardrobe2 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-2.jpg";
const contemporaryWardrobe3 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-3.jpg";
const contemporaryWardrobe4 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-4.jpg";
const contemporaryWardrobe5 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-5.jpg";
const contemporaryWardrobe6 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-6.jpg";
const contemporaryWardrobe7 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-7.jpg";
const contemporaryWardrobe8 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-8.jpg";
const contemporaryWardrobe9 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-9.webp";
const contemporaryWardrobe10 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-10.webp";
const contemporaryWardrobe11 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-11.webp";
const contemporaryWardrobe12 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-12.webp";
const contemporaryWardrobe13 = "https://media.lacontessina.com/site/src/assets/products/contemporary-wardrobe-13.webp";
const contemporaryBathroom1 = "https://media.lacontessina.com/site/src/assets/products/contemporary-bathroom-1.jpg";
const classicLibraries1 = "https://media.lacontessina.com/site/src/assets/products/classic-libraries-1.jpg";
const classicLibraries2 = "https://media.lacontessina.com/site/src/assets/products/classic-libraries-2.jpg";
const classicLibraries3 = "https://media.lacontessina.com/site/src/assets/products/classic-libraries-3.jpg";
const classicBoiserie1 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-1.webp";
const classicBoiserie2 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-2.webp";
const classicBoiserie3 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-3.webp";
const classicBoiserie4 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-4.webp";
const classicBoiserie5 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-5.webp";
const classicBoiserie6 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-6.webp";
const classicBoiserie7 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-7.webp";
const classicBoiserie8 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-8.webp";
const classicBoiserie11 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-11.webp";
const classicBoiserie9 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-9.webp";
const classicBoiserie10 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-10.webp";
const classicBoiserie12 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-12.webp";
const classicBoiserie13 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-13.jpeg";
const classicBoiserie14 = "https://media.lacontessina.com/site/src/assets/products/classic-boiserie-14.jpeg";
const classicWardrobe1 = "https://media.lacontessina.com/site/src/assets/products/classic-wardrobe-1.jpg";
const classicWardrobe2 = "https://media.lacontessina.com/site/src/assets/products/classic-wardrobe-2.jpg";
const classicWardrobe3 = "https://media.lacontessina.com/site/src/assets/products/classic-wardrobe-3.jpg";
const classicWardrobe4 = "https://media.lacontessina.com/site/src/assets/products/classic-wardrobe-4.jpg";
const classicWardrobe5 = "https://media.lacontessina.com/site/src/assets/products/classic-wardrobe-5.jpg";
const classicWardrobe6 = "https://media.lacontessina.com/site/src/assets/products/classic-wardrobe-6.jpg";
const classicWardrobe7 = "https://media.lacontessina.com/site/src/assets/products/classic-wardrobe-7.jpg";
const classicWardrobe8 = "https://media.lacontessina.com/site/src/assets/products/classic-wardrobe-8.jpg";
const textileUpholstered1 = "https://media.lacontessina.com/site/src/assets/products/textile-upholstered-1.jpg";
const textileUpholstered2 = "https://media.lacontessina.com/site/src/assets/products/textile-upholstered-2.jpg";
const textileUpholstered3 = "https://media.lacontessina.com/site/src/assets/products/textile-upholstered-3.jpg";
const textileUpholstered4 = "https://media.lacontessina.com/site/src/assets/products/textile-upholstered-4.jpg";
const textileUpholstered5 = "https://media.lacontessina.com/site/src/assets/products/textile-upholstered-5.jpg";
const textileUpholstered6 = "https://media.lacontessina.com/site/src/assets/products/textile-upholstered-6.jpg";
const textileUpholstered7 = "https://media.lacontessina.com/site/src/assets/products/textile-upholstered-7.jpg";
const textileUpholstered8 = "https://media.lacontessina.com/site/src/assets/products/textile-upholstered-8.jpg";
const textileCurtains1 = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-1.jpg";
const textileCurtains2 = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-2.jpg";
const textileCurtains3 = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-3.jpg";
const textileCurtains4 = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-4.jpg";
const textileCurtains5 = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-5.jpg";
const textileCurtains6 = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-6.jpg";
const textileCurtains7 = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-7.jpg";
const textileCurtains8 = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-8.jpg";
const textileCurtains9 = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-9.jpg";
const textileCurtains10 = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-10.jpg";
const textileCurtains11 = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-11.jpg";
const textileCurtains12 = "https://media.lacontessina.com/site/src/assets/products/textile-curtains-12.jpg";
const textileBedspreadsHero = "https://media.lacontessina.com/site/src/assets/products/textile-bedspreads-hero.jpg";
const textileBedspreads1 = "https://media.lacontessina.com/site/src/assets/products/textile-bedspreads-1.jpg";
const textileBedspreads2 = "https://media.lacontessina.com/site/src/assets/products/textile-bedspreads-2.jpg";
const textileBedspreads3 = "https://media.lacontessina.com/site/src/assets/products/textile-bedspreads-3.jpg";
const textileBedspreads4 = "https://media.lacontessina.com/site/src/assets/products/textile-bedspreads-4.jpg";
const textileBedspreads5 = "https://media.lacontessina.com/site/src/assets/products/textile-bedspreads-5.jpg";
const textileBedspreads6 = "https://media.lacontessina.com/site/src/assets/products/textile-bedspreads-6.jpg";
const textileTablecovers1 = "https://media.lacontessina.com/site/src/assets/products/textile-tablecovers-1.jpg";
const textileTablecovers2 = "https://media.lacontessina.com/site/src/assets/products/textile-tablecovers-2.jpg";
const textileTablecovers3 = "https://media.lacontessina.com/site/src/assets/products/textile-tablecovers-3.jpg";
const textileTablecovers4 = "https://media.lacontessina.com/site/src/assets/products/textile-tablecovers-4.jpg";
const textileTablecovers5 = "https://media.lacontessina.com/site/src/assets/products/textile-tablecovers-5.jpg";
const textileTablecovers6 = "https://media.lacontessina.com/site/src/assets/products/textile-tablecovers-6.jpg";
const textileTablecoversHero = "https://media.lacontessina.com/site/src/assets/products/textile-tablecovers-hero.jpg";
const textileCushions1 = "https://media.lacontessina.com/site/src/assets/products/textile-cushions-1.jpg";
const textileCushions2 = "https://media.lacontessina.com/site/src/assets/products/textile-cushions-2.jpg";
const textileCushions3 = "https://media.lacontessina.com/site/src/assets/products/textile-cushions-3.jpg";
const textileCushions4 = "https://media.lacontessina.com/site/src/assets/products/textile-cushions-4.jpg";
const textileCushions5 = "https://media.lacontessina.com/site/src/assets/products/textile-cushions-5.jpg";
const textileCushions6 = "https://media.lacontessina.com/site/src/assets/products/textile-cushions-6.jpg";
const r_guardaroba_foto_generale_la_contessina = "https://media.lacontessina.com/site/src/assets/products/remote/guardaroba-foto-generale-la-contessina.webp";
const r_ufficio_foto_generale = "https://media.lacontessina.com/site/src/assets/products/remote/ufficio-foto-generale.webp";
const r_boiserie_project_800x800 = "https://media.lacontessina.com/site/src/assets/products/remote/boiserie-project-800x800.webp";
const r_cucina_avorio_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/cucina-avorio-900x900.webp";
const r_cucina_dettaglio_cassetto_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/cucina-dettaglio-cassetto-900x900.webp";
const r_mobili_di_lusso_la_contessina = "https://media.lacontessina.com/site/src/assets/products/remote/mobili-di-lusso-la-contessina.webp";
const r_la_contessina_portofino_tenda_ambientata_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/la-contessina-portofino-tenda-ambientata-900x900.webp";
const r_la_contessina_tenda_imperiale_dettaglio_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/la-contessina-tenda-imperiale-dettaglio-900x900.webp";
const r_la_contessina_tenda_ambientata_botticelli_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/la-contessina-tenda-ambientata-botticelli-900x900.webp";
const r_la_contessina_tenda_ambientata_canaletto = "https://media.lacontessina.com/site/src/assets/products/remote/la-contessina-tenda-ambientata-canaletto.webp";
const r_r602_tenda_ambientata_nr_2_contessina_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/r602-tenda-ambientata-nr--2-contessina-900x900.webp";
const r_versailles_cucina_std_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/versailles-cucina-std-900x900.webp";
const r_foto_1_2_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-1-2-1000x1000.webp";
const r_foto_1_3_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-1-3-1000x1000.webp";
const r_foto_2_3_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-2-3-1000x1000.webp";
const r_foto_2_4_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-2-4-1000x1000.webp";
const r_foto_2_800x800 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-2-800x800.webp";
const r_foto_3_1_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-3-1-900x900.webp";
const r_foto_3_5_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-3-5-1000x1000.webp";
const r_foto_3_800x800 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-3-800x800.webp";
const r_foto_4_1_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-4-1-900x900.webp";
const r_foto_4_4_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-4-4-1000x1000.webp";
const r_foto_4_5_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-4-5-1000x1000.webp";
const r_foto_4_800x800 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-4-800x800.webp";
const r_foto_5_3_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-5-3-1000x1000.webp";
const r_foto_5_800x800 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-5-800x800.webp";
const r_foto_6_3_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-6-3-1000x1000.webp";
const r_foto_6_800x800 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-6-800x800.webp";
const r_foto_7_1_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-7-1-900x900.webp";
const r_foto_7_3_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-7-3-1000x1000.webp";
const r_foto_7_800x800 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-7-800x800.webp";
const r_foto_8_1_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-8-1-900x900.webp";
const r_foto_8_800x800 = "https://media.lacontessina.com/site/src/assets/products/remote/foto-8-800x800.webp";
const r_img_1_versailles_cucina = "https://media.lacontessina.com/site/src/assets/products/remote/1-versailles-cucina.webp";
const r_img_3_ufficio = "https://media.lacontessina.com/site/src/assets/products/remote/3-ufficio.webp";
const r_img_5_versailles_cucina_nera_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/5-versailles-cucina-nera-900x900.webp";
const r_img_8_mobile = "https://media.lacontessina.com/site/src/assets/products/remote/8-mobile.webp";
const r_bagno_cover = "https://media.lacontessina.com/site/src/assets/products/remote/bagno-cover.webp";
const r_cucine_cover = "https://media.lacontessina.com/site/src/assets/products/remote/cucine-cover.webp";
const r_guardaroba_cover = "https://media.lacontessina.com/site/src/assets/products/remote/guardaroba-cover.webp";
const r_hypnose_bagno_01_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-bagno-01-1000x1000.webp";
const r_hypnose_bagno_02_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-bagno-02-1000x1000.webp";
const r_hypnose_bagno_03_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-bagno-03-1000x1000.webp";
const r_hypnose_cuc_01_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-cuc-01-1000x1000.webp";
const r_hypnose_cuc_02_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-cuc-02-1000x1000.webp";
const r_hypnose_cuc_03_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-cuc-03-1000x1000.webp";
const r_hypnose_cuc_04_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-cuc-04-1000x1000.webp";
const r_hypnose_cuc_05_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-cuc-05-1000x1000.webp";
const r_hypnose_immagine_01_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-01-1000x1000.webp";
const r_hypnose_immagine_02_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-02-1000x1000.webp";
const r_hypnose_immagine_03_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-03-1000x1000.webp";
const r_hypnose_immagine_04_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-04-1000x1000.webp";
const r_hypnose_immagine_05_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-05-1000x1000.webp";
const r_hypnose_immagine_06_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-06-1000x1000.webp";
const r_hypnose_immagine_07_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-07-1000x1000.webp";
const r_hypnose_immagine_08_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-08-1000x1000.webp";
const r_hypnose_immagine_09_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-09-1000x1000.webp";
const r_hypnose_immagine_10_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-10-1000x1000.webp";
const r_hypnose_immagine_11_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-11-1000x1000.webp";
const r_hypnose_immagine_12_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-12-1000x1000.webp";
const r_hypnose_immagine_13_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-13-1000x1000.webp";
const r_hypnose_immagine_14_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/hypnose-immagine-14-1000x1000.webp";
const r_mobili_cover = "https://media.lacontessina.com/site/src/assets/products/remote/mobili-cover.webp";
const r_cucina_01_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/cucina-01-900x900.webp";
const r_cucina_02 = "https://media.lacontessina.com/site/src/assets/products/remote/cucina-02.webp";
const r_cucina_03_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/cucina-03-900x900.webp";
const r_cucina_04_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/cucina-04-900x900.webp";
const r_cucina_05 = "https://media.lacontessina.com/site/src/assets/products/remote/cucina-05.webp";
const r_cucina_06_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/cucina-06-900x900.webp";
const r_cucina_07_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/cucina-07-900x900.webp";
const r_cucina_08_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/cucina-08-900x900.webp";
const r_cucina_09_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/cucina-09-900x900.webp";
const r_cucina_10_900x900 = "https://media.lacontessina.com/site/src/assets/products/remote/cucina-10-900x900.webp";
const r_librerie_sfondo = "https://media.lacontessina.com/site/src/assets/products/remote/librerie-sfondo.webp";
const r_ufficio_01_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/ufficio-01-1000x1000.webp";
const r_ufficio_02_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/ufficio-02-1000x1000.webp";
const r_ufficio_03_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/ufficio-03-1000x1000.webp";
const r_ufficio_04_1000x1000 = "https://media.lacontessina.com/site/src/assets/products/remote/ufficio-04-1000x1000.webp";
export interface LeafContent {
  hero: string;
  /** uppercased subtitle line (under italic family name) */
  subtitleKey: string;
  /** H2 title key (defaults to family-leaf title) */
  titleKey: string;
  /** body paragraph i18n keys */
  bodyKeys: string[];
  /** catalogue CTA i18n key (uppercased) */
  ctaKey?: string;
  gallery: string[];
}


/**
 * Content map mirroring the original site.
 * Keys reference existing translations under `products.leaf.<family>.<leaf>.*`.
 */
export const LEAF_DATA: Record<ProductFamily, Record<string, LeafContent>> = {
  classic: {
    furniture: {
      hero: r_foto_2_800x800,
      titleKey: "products.leaf.classic.furniture.title",
      subtitleKey: "products.leaf.classic.furniture.subtitle",
      bodyKeys: [
        "products.leaf.classic.furniture.col1",
        "products.leaf.classic.furniture.col2",
      ],
      ctaKey: "products.leaf.classic.furniture.cta",
      gallery: [
        r_boiserie_project_800x800,
        r_foto_2_800x800,
        r_foto_3_800x800,
        r_foto_4_800x800,
        r_foto_5_800x800,
        r_foto_6_800x800,
        r_foto_7_800x800,
        r_foto_8_800x800,
      ],
    },
    kitchens: {
      hero: r_img_1_versailles_cucina,
      titleKey: "products.leaf.classic.kitchens.title",
      subtitleKey: "products.leaf.classic.kitchens.subtitle",
      bodyKeys: [
        "products.leaf.classic.kitchens.col1",
        "products.leaf.classic.kitchens.col2",
      ],
      ctaKey: "products.leaf.classic.kitchens.cta",
      gallery: [
        r_cucina_01_900x900,
        r_cucina_02,
        r_cucina_03_900x900,
        r_cucina_04_900x900,
        r_cucina_05,
        r_cucina_06_900x900,
        r_cucina_07_900x900,
        r_cucina_08_900x900,
        r_cucina_09_900x900,
        r_cucina_10_900x900,
        r_img_5_versailles_cucina_nera_900x900,
        r_versailles_cucina_std_900x900,
        r_cucina_avorio_900x900,
        r_cucina_dettaglio_cassetto_900x900,
        r_foto_3_1_900x900,
        r_foto_4_1_900x900,
        r_foto_7_1_900x900,
        r_foto_8_1_900x900,
      ],
    },
    wardrobe: {
      hero: r_guardaroba_foto_generale_la_contessina,
      titleKey: "products.leaf.classic.wardrobe.title",
      subtitleKey: "products.leaf.classic.wardrobe.subtitle",
      bodyKeys: [],
      gallery: [
        classicWardrobe1,
        classicWardrobe2,
        classicWardrobe3,
        classicWardrobe4,
        classicWardrobe5,
        classicWardrobe6,
        classicWardrobe7,
        classicWardrobe8,
      ],
    },
    office: {
      hero: r_ufficio_foto_generale,
      titleKey: "products.leaf.classic.office.title",
      subtitleKey: "products.leaf.classic.office.subtitle",
      bodyKeys: [
        "products.leaf.classic.office.col1",
        "products.leaf.classic.office.col2",
      ],
      ctaKey: "products.leaf.classic.office.cta",
      gallery: [
        r_ufficio_01_1000x1000,
        r_ufficio_02_1000x1000,
        r_ufficio_03_1000x1000,
        r_ufficio_04_1000x1000,
        r_foto_1_2_1000x1000,
        r_foto_2_3_1000x1000,
        r_foto_4_4_1000x1000,
        r_img_3_ufficio,
      ],
    },
    libraries: {
      hero: r_librerie_sfondo,
      titleKey: "products.leaf.classic.libraries.title",
      subtitleKey: "",
      bodyKeys: [],
      gallery: [classicLibraries1, classicLibraries2, classicLibraries3],
    },
    boiserie: {
      hero: classicBoiserie1,
      titleKey: "products.leaf.classic.boiserie.title",
      subtitleKey: "",
      bodyKeys: [],
      gallery: [
        classicBoiserie1,
        classicBoiserie2,
        classicBoiserie3,
        classicBoiserie4,
        classicBoiserie5,
        classicBoiserie6,
        classicBoiserie7,
        classicBoiserie8,
        classicBoiserie11,
        classicBoiserie9,
        classicBoiserie10,
        classicBoiserie12,
        classicBoiserie13,
        classicBoiserie14,
      ],
    },
  },
  contemporary: {
    furniture: {
      hero: contemporaryFurniture3,
      titleKey: "products.leaf.contemporary.furniture.title1",
      subtitleKey: "products.leaf.contemporary.furniture.subtitle",
      bodyKeys: [],
      gallery: [
        contemporaryFurniture1,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-1.jpeg",
        contemporaryFurniture2,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-2.jpeg",
        contemporaryFurniture3,
        contemporaryFurniture4,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-3.jpeg",
        contemporaryFurniture5,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-4.jpeg",
        contemporaryFurniture6,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-5.jpeg",
        contemporaryFurniture7,
        contemporaryFurniture8,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-6.jpeg",
        contemporaryFurniture9,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-7.jpeg",
        contemporaryFurniture10,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-8.jpeg",
        r_hypnose_immagine_01_1000x1000,
        r_hypnose_immagine_02_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-9.jpeg",
        r_hypnose_immagine_03_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-10.jpeg",
        r_hypnose_immagine_04_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-11.jpeg",
        r_hypnose_immagine_05_1000x1000,
        r_hypnose_immagine_06_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-12.jpeg",
        r_hypnose_immagine_07_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-13.jpeg",
        r_hypnose_immagine_08_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-14.jpeg",
        r_hypnose_immagine_09_1000x1000,
        r_hypnose_immagine_10_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-15.jpeg",
        r_hypnose_immagine_11_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-16.jpeg",
        r_hypnose_immagine_12_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-17.jpeg",
        r_hypnose_immagine_13_1000x1000,
        r_hypnose_immagine_14_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-18.jpeg",
        r_foto_1_3_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-19.jpeg",
        r_foto_2_4_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-20.jpeg",
        r_foto_3_5_1000x1000,
        r_foto_4_5_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-21.jpeg",
        r_foto_5_3_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-22.jpeg",
        r_foto_6_3_1000x1000,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-23.jpeg",
        r_foto_7_3_1000x1000,
        r_img_8_mobile,
        "https://media.lacontessina.com/site/src/assets/products/new/contemporary-furniture-new-24.jpeg",
      ],
    },
    kitchens: {
      hero: r_cucine_cover,
      titleKey: "products.leaf.contemporary.kitchens.title1",
      subtitleKey: "products.leaf.contemporary.kitchens.subtitle",
      bodyKeys: [],
      gallery: [
        contemporaryKitchen1,
        contemporaryKitchen2,
        contemporaryKitchen3,
        r_hypnose_cuc_01_1000x1000,
        r_hypnose_cuc_02_1000x1000,
        r_hypnose_cuc_03_1000x1000,
        r_hypnose_cuc_04_1000x1000,
        r_hypnose_cuc_05_1000x1000,
      ],
    },
    wardrobe: {
      hero: r_guardaroba_cover,
      titleKey: "products.leaf.contemporary.wardrobe.title",
      subtitleKey: "products.leaf.contemporary.wardrobe.subtitle",
      bodyKeys: [],
      gallery: [
        contemporaryWardrobe1,
        contemporaryWardrobe2,
        contemporaryWardrobe3,
        contemporaryWardrobe4,
        contemporaryWardrobe5,
        contemporaryWardrobe6,
        contemporaryWardrobe7,
        contemporaryWardrobe8,
        contemporaryWardrobe9,
        contemporaryWardrobe10,
        contemporaryWardrobe11,
        contemporaryWardrobe12,
        contemporaryWardrobe13,
      ],
    },
    bathroom: {
      hero: r_bagno_cover,
      titleKey: "products.leaf.contemporary.bathroom.title1",
      subtitleKey: "",
      bodyKeys: [],
      gallery: [
        contemporaryBathroom1,
        r_hypnose_bagno_01_1000x1000,
        r_hypnose_bagno_02_1000x1000,
        r_hypnose_bagno_03_1000x1000,
      ],
    },
  },
  textile: {
    curtains: {
      hero: textileCurtains1,
      titleKey: "header.products.textile.curtains",
      subtitleKey: "products.leaf.textile.subtitle",
      bodyKeys: ["products.leaf.textile.col1", "products.leaf.textile.col2"],
      ctaKey: "products.leaf.textile.cta",
      gallery: [
        textileCurtains1,
        textileCurtains2,
        textileCurtains3,
        textileCurtains4,
        textileCurtains5,
        textileCurtains6,
        textileCurtains7,
        textileCurtains8,
      ],
    },
    bedspreads: {
      hero: textileBedspreadsHero,
      titleKey: "header.products.textile.bedspreads",
      subtitleKey: "products.leaf.textile.subtitle",
      bodyKeys: ["products.leaf.textile.col1", "products.leaf.textile.col2"],
      ctaKey: "products.leaf.textile.cta",
      gallery: [
        textileBedspreads1,
        textileBedspreads2,
        textileBedspreads3,
        textileBedspreads4,
        textileBedspreads5,
        textileBedspreads6,
      ],
    },
    tablecovers: {
      hero: textileTablecoversHero,
      titleKey: "header.products.textile.tablecovers",
      subtitleKey: "products.leaf.textile.subtitle",
      bodyKeys: ["products.leaf.textile.col1", "products.leaf.textile.col2"],
      ctaKey: "products.leaf.textile.cta",
      gallery: [
        textileTablecovers1,
        textileTablecovers2,
        textileTablecovers3,
        textileTablecovers4,
        textileTablecovers5,
        textileTablecovers6,
      ],
    },
    cushions: {
      hero: textileCushions4,
      titleKey: "header.products.textile.cushions",
      subtitleKey: "products.leaf.textile.subtitle",
      bodyKeys: ["products.leaf.textile.col1", "products.leaf.textile.col2"],
      ctaKey: "products.leaf.textile.cta",
      gallery: [
        textileCushions1,
        textileCushions2,
        textileCushions3,
        textileCushions4,
        textileCushions5,
        textileCushions6,
      ],
    },
  },
};